export const CARGO_CATEGORIES = [
    { value: 'Agricultural and Raw Materials', label: 'Agricultural and Raw Materials' },
    { value: 'Apparel and Personal Care', label: 'Apparel and Personal Care' },
    { value: 'Automotive and Vehicles', label: 'Automotive and Vehicles' },
    { value: 'Consumer Electronics', label: 'Consumer Electronics' },
    { value: 'Home and Household', label: 'Home and Household' },
    { value: 'Food and Beverages', label: 'Food and Beverages' },
    { value: 'Pharmaceuticals and Healthcare', label: 'Pharmaceuticals and Healthcare' },
    { value: 'Tobacco and Alcohol', label: 'Tobacco and Alcohol' },
    { value: 'Tools and Construction', label: 'Tools and Construction' },
    { value: 'Valuables and Financial', label: 'Valuables and Financial' },
    { value: 'Sports and Leisure', label: 'Sports and Leisure' },
    { value: 'Other', label: 'Other' },
];
